
import { IKeHoachHocLaiAddMonHocRequest } from "../../../model/request/ke-hoach-hoc-lai/IKeHoachHocLaiAddMonHocRequest";
import { IKeHoachMonHocLaiUpdateInfoSuKienRequest } from "../../../model/request/ke-hoach-hoc-lai/IKeHoachMonHocLaiUpdateInfoSuKienRequest";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { ILopTinChiPhamViUpdateRequest } from "../../../model/request/lop-tin-chi/ILopTinChiPhamViUpdateRequest";
import { IKeHoachMonHocLaiVm } from "../../../model/respone/ke-hoach/IKeHoachMonHocLaiVm";
import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";
import { IPhamViDangKyLop } from "../../../model/respone/lop-tin-chi/IPhamViDangKyLop";
import { ISuKienViewModel } from "../../../model/respone/lop-tin-chi/ISuKienViewModel";
import { IKeHoachHocLaiAddMonHocModal, IKeHoachHocLaiFilter } from "../../reducer-model/ke-hoach-hoc-lai/IKeHoachHocLaiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachHocLaiActionObj = {
    CHANGE_FILTER: {} as IKeHoachHocLaiFilter,
    UPDATE_ADD_MONHOC_MODAL: {} as IKeHoachHocLaiAddMonHocModal,

    ADD_MONHOC_START: {} as IKeHoachMonAddRequest, //IKeHoachHocLaiAddMonHocRequest,
    ADD_MONHOC_SUCCESS: undefined,
    ADD_MONHOC_ERROR: "",

    LOAD_START: {} as IKeHoachHocLaiFilter,
    LOAD_SUCCESS: {} as IKeHoachMonHocLaiVm[],
    LOAD_ERROR: "",

    SHOW_PHAM_VI_LOP_MODAL: {} as boolean,
    CHANGE_FOCUSED_ID: {} as number,

    SAVE_PHAM_VI_START: {} as ILopTinChiPhamViUpdateRequest,
    SAVE_PHAM_VI_SUCCESS: {} as IPhamViDangKyLop[],
    SAVE_PHAM_VI_ERROR: "",
    
    UPDATE_INFO_SU_KIEN_START: {} as IKeHoachMonHocLaiUpdateInfoSuKienRequest[],
    UPDATE_INFO_SU_KIEN_SUCCESS: {} as ISuKienViewModel[],
    UPDATE_INFO_SU_KIEN_ERROR: "",

    UPDATE_LOP_TIN_CHI_START: {} as ILopTinChiViewModel,
    UPDATE_LOP_TIN_CHI_SUCCESS: {} as ILopTinChiViewModel,
    UPDATE_LOP_TIN_CHI_ERROR: "",
    
    CHANGE_SORT_MODE: {} as "lich-hoc" | "lich-thi",
};
export const eKeHoachHocLaiActionIds = generateActionTypeIds(
    eKeHoachHocLaiActionObj,
    "KE_HOACH_HOC_LAI"
);
export type IKeHoachHocLaiActions = IGenericActionType<
    typeof eKeHoachHocLaiActionObj,
    "KE_HOACH_HOC_LAI"
>;
